module.exports = __webpack_public_path__ + "img/av223.895edd83.png";